import { Routes } from '@angular/router';

export const partnersRoutes: Routes = [
  {
    path: 'partners',
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/partners-list-page/partners-list-page.component'
          ).then((m) => m.PartnersListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/partners-detail-page/partners-detail-page.component'
              ).then((m) => m.PartnersDetailPageComponent),
          },
        ],
      },
    ],
  },
];
